"use client";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useRouter } from "next/navigation";
import understand from "../../public/assets/images/project-price/understand.png";
import "./components.css";
import Image from "next/image";
import CommonButton from "./CommonButton";

const RedirectModal = ({ show, onHide, quoteId }) => {
  const [countdown, setCountdown] = useState(5);
  const router = useRouter();

  useEffect(() => {
    if (!show) return;

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      clearInterval(timer);
      // router.push(`/packages?quoteId=${quoteId}`); // navigate
    }, 5000); // 10 seconds

    return () => {
      clearInterval(timer);
      clearInterval(timeout);
    };
  }, [show, onHide, router]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="confirmation-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3 className="com-title" style={{ fontSize: "20px" }}>
            Explore Packages That <span>Match Your Needs</span>
          </h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Image
          src={understand}
          alt={" Explore Packages That Match Your Needs"}
          height={300}
          width={300}
          className="img-fluid mx-auto d-block"
        />
        <p className="text-center">
          Every project is unique — if this package doesn’t fit your needs,
          explore our other options tailored to different goals, sizes, and
          timelines. Your vision matters, and we’re here to match it.
        </p>

        <div className="d-flex justify-content-center align-items-center gap-2">
          <CommonButton
            label="View Pricing"
            disabled={countdown > 0}
            onClick={() => {
              onHide();
              router.push(`/packages?quoteId=${quoteId}`);
            }}
          />
          {countdown > 0 && <div className="count-text">00:0{countdown}</div>}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RedirectModal;
